import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';
import { CSSProperties } from 'react';

export default function ListagemCreditosHomeFallbackMobile(props: {
  style?: CSSProperties;
}) {
  const { style = {} } = props;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing[5],
        paddingTop: theme.spacing[5],
        paddingBottom: theme.spacing[2],
        paddingLeft: theme.spacing[4],
        paddingRight: theme.spacing[4],
        ...style,
      }}
    >
      <Skeleton style={{ width: '65vw', height: 32 }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.spacing[4],
          overflow: 'hidden',
        }}
      >
        <Skeleton
          style={{ width: 68, height: 38, marginRight: theme.spacing[4] }}
        />
        <Skeleton
          style={{ width: 99, height: 38, marginRight: theme.spacing[4] }}
        />
        <Skeleton
          style={{ width: 75, height: 38, marginRight: theme.spacing[4] }}
        />
        <Skeleton
          style={{ width: 75, height: 38, marginRight: theme.spacing[4] }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[2],
        }}
      >
        <Skeleton style={{ height: 76, marginTop: theme.spacing[7] }} />
        <Skeleton style={{ height: 76, marginTop: theme.spacing[2] }} />
        <Skeleton style={{ height: 76, marginTop: theme.spacing[2] }} />
        <Skeleton
          style={{ height: 76, marginTop: 8, marginBottom: theme.spacing[2] }}
        />
      </div>
    </div>
  );
}
